import { useGame } from "../../app/GameProvider.js";

export function TitleScreen() {
  const { dispatch, loadError } = useGame();

  return (
    <section className="screen screen-title">
      <h1>タイトル未定</h1>
      {loadError ? <p className="hint">{loadError}</p> : null}
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => dispatch({ type: "OPEN_STAGE_SELECT" })}
      >
        はじめる
      </button>
    </section>
  );
}
